import { Menu } from "./Menu.js"
import { Topbar } from "./Topbar.js";
import { useState, useEffect } from "react"
import "./Navbar.scss"
export function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 900);

  useEffect(() => {
    function update() {
      const desktop = window.innerWidth >= 900;
      setIsDesktop(desktop);
      // if desktop, show menu inline; if mobile, hide overlay by default
      setShowMenu(desktop ? true : false);
    }
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  function propShowFullMenu(status) {
    return setShowMenu(status)
  }

  return (
    <div className="app navbar">
      <Topbar propShowFullMenu={propShowFullMenu} isDesktop={isDesktop} />
      {/* Render overlay menu only on non-desktop */}
      {!isDesktop && (
        <div className={showMenu ? "fade-in" : ""}>
          {showMenu && <Menu />}
        </div>
      )}
    </div>
  )
}